import { FI_MENU_ICON_CLIPBOARD } from './editorjs-fi-menu-icons';

export type AiInstructionsEditRequest = {
  initialText: string;
  onCommit: (text: string) => void;
};

type AiInstructionsTuneConfig = {
  onRequestAiInstructionsEdit?: (request: AiInstructionsEditRequest) => void;
};

function normalizeTuneData(raw: unknown): string {
  return typeof raw === 'string' ? raw : '';
}

/**
 * Global block tune: per-block AI instructions stored under `tunes.aiInstructions`
 * in saved Editor.js output.
 */
export default class AiInstructionsTune {
  static get isTune() {
    return true;
  }

  private readonly api: any;
  private readonly config: AiInstructionsTuneConfig;
  private readonly block: any;
  private instructionsText: string;

  constructor({ api, config, block, data }: any) {
    this.api = api;
    this.config = config ?? {};
    this.block = block;
    this.instructionsText = normalizeTuneData(data);
  }

  save(): string {
    return this.instructionsText;
  }

  render() {
    const t = this.api?.i18n?.t as undefined | ((key: string) => string);
    const title = t?.('Instructions') ?? 'Instructions';

    return {
      icon: FI_MENU_ICON_CLIPBOARD,
      title,
      closeOnActivate: true,
      onActivate: () => {
        const open = this.config?.onRequestAiInstructionsEdit;
        if (typeof open !== 'function') return;

        open({
          initialText: this.instructionsText,
          onCommit: (next: string) => {
            this.instructionsText = next;
            this.block?.dispatchChange?.();
          },
        });
      },
    };
  }
}
